export default function(x) {
  return function() {
    return x;
  };
}



//////////////////
// WEBPACK FOOTER
// /home/circleci/pickle/~/d3-array/src/constant.js
// module id = OKWp
// module chunks = 0